module.exports = __webpack_public_path__ + "static/vis-reg-report-0bb0827409dc5cda35447edb450ebe9e.png";